/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { FC, useEffect, useState } from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { PrivateRoutes } from './PrivateRoutes'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { Logout, AuthPage } from '../modules/auth'
import { App } from '../App'
import AuthService from '../modules/auth/redux/AuthService'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */

const AppRoutes: FC = () => {

  const [isAuthorized, setIsAuthorized] = useState<boolean>(false)
  const usr = AuthService.GetCurrentUser();

  useEffect(() => {  
    if((usr && usr.userData && usr.userData.roles && usr.userData.roles.includes('Ajans')) || (usr && usr.userData && usr.userData.roles && usr.userData.roles.includes('Ajans Admin'))) {
      setIsAuthorized(true)
    }
  }, [usr])


  return (
    <BrowserRouter basename='/influencer'>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          {((usr && usr.userData && usr.userData.roles && usr.userData.roles.includes('Ajans')) || (usr && usr.userData && usr.userData.roles && usr.userData.roles.includes('Ajans Admin')))  ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/list' />} />
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
